"use strict";

var _toConsumableArray = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUniversalReporter = void 0;

var EventSender_1 = require("../reporters/EventSender");

var contexts_1 = require("@spotify-internal/event-sender/es5/contexts");

function createUniversalReporter() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = config.context ? [contexts_1.createUserAgentContext()].concat(_toConsumableArray(config.context)) : [contexts_1.createUserAgentContext()];
  return EventSender_1.EventSenderReporter.create(Object.assign(Object.assign({
    environment: 'browser'
  }, config), {
    context: context
  }));
}

exports.createUniversalReporter = createUniversalReporter;